import { DateRangeField, DecoratedFormUnit, SwitchField } from '@mi-front/ui';
import { useFormikContext } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import { StationsTimezoneSelect } from '../../../../../../components/stations/StationsTimezoneSelect';
import { useTimezone } from '../../../../../../core/hooks';
import { AuditStationsSelect } from '../../../../components/AuditStationsSelect';
import { GlobalSchedulesNoMatchesReport } from '../types';

export const GlobalSchedulesNoMatchesReportForm = () => {
  const { $t } = useIntl();
  const tz = useTimezone();
  const fp = useFormikContext<GlobalSchedulesNoMatchesReport['Values']>();

  return (
    <div>
      <div className="row">
        <div className="col-4">
          <DecoratedFormUnit
            label={$t({
              id: 'common.datetimeRange',
              defaultMessage: 'Rango de fecha y hora',
            })}
          >
            <DateRangeField name={['from', 'to']} tz={tz} />
          </DecoratedFormUnit>
        </div>
        <div className="col-4">
          <StationsTimezoneSelect
            disabled={fp.isSubmitting}
            onChange={(value: string) => fp.setFieldValue('timezone', value)}
            value={fp.values.timezone}
          />
        </div>
        <div className="col-4 align-self-center">
          <div className={'d-flex align-items-center'}>
            <SwitchField size="sm" name="includeMissingAudio" />
            &nbsp;&nbsp;
            <FormattedMessage
              id="audit.schedulesNoMatches.includeMissingAudio"
              defaultMessage="Incluir schedules con archivos faltante"
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-9">
          <AuditStationsSelect multiple />
        </div>
      </div>
    </div>
  );
};
